var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"signup-selection"}},[_c('div',{staticClass:"signup-selection-container"},[_c('LeftView',{attrs:{"coverImage":_vm.coverImage}}),_c('RightView')],1),_c('div',{staticClass:"right-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }